import React from "react";
import Header from "./Header";
import Home from "./Home";
import Footer from "./Footer";
import Pagenotfound from "./Pagenotfound";
import { BrowserRouter, Switch, Route } from "react-router-dom";


function App() {
  return (
    <>
      <BrowserRouter>



        <Header />
        <Switch>

          <Route path="/" component={Home} exact />
          <Route path="" component={Pagenotfound} exact />

        </Switch>
        <Footer />



      </BrowserRouter>
    </>
  );
}

export default App;
